import { CognitoUserPool } from "amazon-cognito-identity-js"

export const userPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP__BACKEND_STACK__UserPoolId!!,
  ClientId: process.env.REACT_APP__BACKEND_STACK__UserPoolClientId!!
})